import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const BuyeasySupplierUserPropertiesTranslations = wrapTranslationsSchema({
	name: 'BuyEasySupplierUserPropertiesTranslations',
	title: 'User Properties Section Translations',
	sanityId: 'buyeasy-supplierUserProperties',
	fields: {
		userPropertiesSectionTitle: 'Information based on User Properties',
		yourProperties: 'Your Properties',
		companyCode: 'Company Code',
		companyCodes: 'Company Codes',
		user: 'User',
		country: 'Country',
		purchasingInformation: 'Purchasing Information',
		purchasingOrg: 'Purchasing Org.',
		purchasingOrganization: 'Purchasing Organization',
		purchasingOrganizations: 'Purchasing Organizations',
		paymentTerms: 'Payment Terms',
		purchasingCurrency: 'Purchasing Currency',
		ersSelf: 'ERS (Self Billing)',
		mdgInvoiceContract: 'MDG Invoice Contact',
		noPurchasingOrgs: 'no purchasing organizations',
		userPurchasingOrgNotListed: 'Your Purchasing Org. is not listed for the Supplier.',
		yourPurchasingOrgDetails: 'Your Purchasing Org. details',
		noMdgContacts: 'no MDG Contacts',
		yourMdgContact: 'Your MGD Invoice Contact',
		mdgInvoiceContractTooltip: 'For Invoicing questions, contact the MDG Invoice Contact.',
		contactBasedOnUsersCode: 'Contact based on User’s company code',
	},
});
